import { useState,useRef } from "react";
import emailjs from "@emailjs/browser";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    company: "",
    message: "",
  });
  const form = useRef();

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_gv6lsml",   // Replace with your EmailJS Service ID
        "template_m3oel4v",  // Replace with your EmailJS Template ID
        formData,
        "vJBxDT3cZPgzmyMcw"   // Replace with your EmailJS Public Key
      )
      .then(
        () => {
          setStatus("Message sent successfully!");
          setFormData({ name: "", email: "", contact: "", company: "", message: "" });
        },
        (error) => {
          setStatus("Failed to send message. Try again!");
          console.error(error);
        }
      );
  };

  return (
    <div className="max-w-lg mx-auto p-6 bg-white shadow-lg rounded-xl mt-10">
      <h2 className="text-2xl font-bold text-gray-800 text-center">Contact Us</h2>
      <p className="text-gray-600 text-center mb-4">Fill in the form and we'll get back to you.</p>

      <form onSubmit={sendEmail} className="space-y-4">
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
        />

        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
        />

        <input
          type="tel"
          name="contact"
          placeholder="Contact Number"
          value={formData.contact}
          onChange={(e) => {
            const newValue = e.target.value;
            // Allow only digits and limit to 10 digits
            if (/^\d{0,10}$/.test(newValue)) {
              handleChange(e);
            }
          }}
          required
          className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
        />

        <input
          type="text"
          name="company"
          placeholder="Company Name"
          value={formData.company}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
        />

        <textarea
          name="message"
          placeholder="Message"
          value={formData.message}
          onChange={handleChange}
          required
          className="w-full p-3 border rounded-lg h-24 focus:ring-2 focus:ring-blue-500"
        ></textarea>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white p-3 rounded-lg font-semibold hover:bg-blue-700 transition"
        >
          Send Message
        </button>
      </form>

      {status && <p className="text-center mt-4 text-green-600">{status}</p>}
    </div>
  );
}
